import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b1d82ca6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "energy-savig content-box pheight",
  id: "page"
}
const _hoisted_2 = {
  class: "energy-top clearfix",
  id: "energy"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "我的节能", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "排名", -1))
const _hoisted_5 = { class: "top-num" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "今天新增", -1))
const _hoisted_7 = { class: "top-num" }
const _hoisted_8 = {
  class: "card",
  id: "air"
}
const _hoisted_9 = { class: "card-top" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "record-title" }, "温度调节统计", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "调节记录", -1))
const _hoisted_12 = { class: "card-box" }
const _hoisted_13 = { class: "temprature-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "累计调节", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "次", -1))
const _hoisted_16 = { class: "temprature-item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "累计调高", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "次", -1))
const _hoisted_19 = { class: "temprature-item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "累计调低", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "次", -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode("空调节能 ")
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "kW·h", -1))
const _hoisted_24 = { class: "chart-content" }
const _hoisted_25 = { class: "chart-btn" }
const _hoisted_26 = {
  key: 1,
  class: "no-data",
  height: "100%",
  width: "100%"
}
const _hoisted_27 = ["src"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "暂无数据", -1))
const _hoisted_29 = {
  key: 0,
  class: "tip-box zero"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip-title" }, "您的调节记录", -1))
const _hoisted_31 = { class: "tip-num" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip-desc" }, [
  /*#__PURE__*/_createElementVNode("p", null, "温度关键词无动于衷")
], -1))
const _hoisted_33 = ["src"]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip-title" }, "您的舒适温度", -1))
const _hoisted_35 = { class: "tip-num" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { key: 2 }
const _hoisted_39 = { class: "tip-desc" }
const _hoisted_40 = ["src"]
const _hoisted_41 = {
  class: "card lamp-card mt30",
  id: "lamp"
}
const _hoisted_42 = { class: "card-top" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "record-title" }, "开关照明统计", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "调节记录", -1))
const _hoisted_45 = { class: "card-box" }
const _hoisted_46 = { class: "temprature-item" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "累计开启", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "次", -1))
const _hoisted_49 = { class: "temprature-item" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "累计关闭", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "次", -1))
const _hoisted_52 = { class: "chart-content mt30" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dailog-content" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "空调节能"),
  /*#__PURE__*/_createElementVNode("p", null, "夏季设定值调高一度，冬季调低两度；"),
  /*#__PURE__*/_createElementVNode("p", null, "相当于省电20%；"),
  /*#__PURE__*/_createElementVNode("p", null, "如果夏季空调温度都设定在26℃以上；"),
  /*#__PURE__*/_createElementVNode("p", null, "如果冬季空调温度都设定在20℃以下；"),
  /*#__PURE__*/_createElementVNode("p", null, "节省的电力是相当可观的")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_com_chart = _resolveComponent("com-chart")!
  const _component_van_dialog = _resolveComponent("van-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "top-item fl",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goDeail && _ctx.goDeail(...args)))
      }, [
        _hoisted_3,
        _createElementVNode("p", null, _toDisplayString(_ctx.energyData.totalPoints || _ctx.energyData.totalPoints == 0 ? _ctx.energyData.totalPoints : '--'), 1)
      ]),
      _createElementVNode("div", {
        class: "top-item pt fr",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goRank && _ctx.goRank(...args)))
      }, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString(_ctx.energyData.level || _ctx.energyData.level == 0 ? _ctx.energyData.level : '--'), 1),
          _createVNode(_component_van_icon, {
            class: "arrow",
            name: "arrow"
          })
        ])
      ]),
      _createElementVNode("div", {
        class: "top-item pt pr fr",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goDeail('today')))
      }, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", null, "+ " + _toDisplayString(_ctx.energyData.intergral || _ctx.energyData.intergral == 0 ? _ctx.energyData.intergral : '--'), 1),
          _createVNode(_component_van_icon, {
            class: "arrow",
            name: "arrow"
          })
        ])
      ])
    ]),
    (_ctx.portait.airConditioner)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("div", {
                class: "record-btn",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goRecord('temp')))
              }, [
                _hoisted_11,
                _createVNode(_component_van_icon, {
                  class: "arrow",
                  name: "arrow"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString((_ctx.tempTotal.adjustTotalNum || _ctx.tempTotal.adjustTotalNum == 0) ? _ctx.tempTotal.adjustTotalNum : '--') + " ", 1),
                  _hoisted_15
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString((_ctx.tempTotal.adjustUpNum || _ctx.tempTotal.adjustUpNum == 0) ? _ctx.tempTotal.adjustUpNum : '--') + " ", 1),
                  _hoisted_18
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString((_ctx.tempTotal.adjustDownNum || _ctx.tempTotal.adjustDownNum == 0) ? _ctx.tempTotal.adjustDownNum : '--') + " ", 1),
                  _hoisted_21
                ])
              ]),
              _createElementVNode("div", {
                class: "temprature-item",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.triggerDailog && _ctx.triggerDailog(...args)))
              }, [
                _createElementVNode("span", null, [
                  _hoisted_22,
                  _createVNode(_component_van_icon, {
                    class: "question",
                    name: "question-o"
                  })
                ]),
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString((_ctx.tempTotal.economizeEnergy || _ctx.tempTotal.economizeEnergy == 0) ? _ctx.tempTotal.economizeEnergy : '--') + " ", 1),
                  _hoisted_23
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.seasonType == 'Cooling'?'active':''),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.triggerSeason('Cooling')))
              }, "供冷季", 2),
              _createElementVNode("span", {
                class: _normalizeClass(_ctx.seasonType == 'Warm'?'active':''),
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.triggerSeason('Warm')))
              }, "供暖季", 2)
            ]),
            (_ctx.options1)
              ? (_openBlock(), _createBlock(_component_com_chart, {
                  key: 0,
                  options: _ctx.options1,
                  id: "chart1",
                  height: "100%",
                  width: "100%"
                }, null, 8, ["options"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("img", {
                    src: _ctx.parseImgUrl('page-officehome','empty.png'),
                    alt: ""
                  }, null, 8, _hoisted_27),
                  _hoisted_28
                ]))
          ]),
          (_ctx.comfortType=='zero'||_ctx.comfortType=='little')
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.adjustNum), 1)
                ]),
                _hoisted_32,
                _createElementVNode("img", {
                  class: "tip-img",
                  src: _ctx.comfortTextObj.img,
                  alt: ""
                }, null, 8, _hoisted_33)
              ]))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["tip-box", {'good':_ctx.comfortType=='good','heat':_ctx.comfortType=='heat'}])
              }, [
                _hoisted_34,
                _createElementVNode("div", _hoisted_35, [
                  (_ctx.lowComfortTemp)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.lowComfortTemp) + "℃", 1))
                    : _createCommentVNode("", true),
                  (_ctx.lowComfortTemp && _ctx.highComfortTemp)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_37, "-"))
                    : _createCommentVNode("", true),
                  (_ctx.highComfortTemp)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_38, _toDisplayString(_ctx.highComfortTemp) + "℃", 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.comfortTextObj.firstLine), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.comfortTextObj.secondLine), 1)
                ]),
                _createElementVNode("img", {
                  class: "tip-img",
                  src: _ctx.comfortTextObj.img,
                  alt: ""
                }, null, 8, _hoisted_40)
              ], 2))
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.portait.light)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _createElementVNode("div", {
                class: "record-btn",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goRecord('light')))
              }, [
                _hoisted_44,
                _createVNode(_component_van_icon, {
                  class: "arrow",
                  name: "arrow"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString((_ctx.lightTotal.openNum || _ctx.lightTotal.openNum == 0) ? _ctx.lightTotal.openNum : '--') + " ", 1),
                  _hoisted_48
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString((_ctx.lightTotal.closeNum || _ctx.lightTotal.closeNum == 0) ? _ctx.lightTotal.closeNum : '--') + " ", 1),
                  _hoisted_51
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_52, [
            (_ctx.options2)
              ? (_openBlock(), _createBlock(_component_com_chart, {
                  key: 0,
                  options: _ctx.options2,
                  id: "chart2",
                  height: "100%",
                  width: "100%"
                }, null, 8, ["options"]))
              : _createCommentVNode("", true)
          ])
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_van_dialog, {
      "confirm-button-text": "我知道了",
      "confirm-button-color": "#000",
      show: _ctx.showDialog,
      "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showDialog) = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_53
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}